import { defineComponent, h } from 'vue';
import { QBtn, QDialog, QTooltip } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';
import ControlPicker from './controlPicker.jsx';

export default defineComponent({
    name: 'for-each-dsgn',
    mixins: [BaseComponentMixin],
    components: {
        QBtn,
        QDialog,
        QTooltip,
        ControlPicker,
    },
    data() {
        return {
            model: [],
            sourceraw: null,
            sourceurl: null,
        };
    },
    computed: {
        style() {
            return {};
        },
        /** Grid-style: stay "selected" while SelectedModel is a ContentDef under this ForEach. */
        selected$() {
            return this.Root.SelectedNode && this.Root.SelectedNode === this;
        },
    },
    mounted() {
        this.Refresh();
    },
    methods: {
        async Refresh() {
            if (this.controlData.SourceType === 'Raw' && this.controlData.SourceRaw && (typeof this.controlData.SourceRaw === 'object')) {
                this.model = this.controlData.SourceRaw;
            }
            else if (this.controlData.SourceType === 'Url' && this.controlData.SourceUrl) {
                try {
                    this.model = await utils.api.get(this.controlData.SourceUrl);
                }
                catch {
                    this.model = [];
                }
            }
        },
        selectContentDef(e, cd) {
            this.Root.SelectNode(this, cd);
            e.cancelBubble = true;
            e.stopPropagation();
            e.preventDefault?.();
        },
        generateItems(h, contentDefs, items, model, index, parentType, isFirstPreviewRow) {
            for (let j = 0; j < contentDefs.length; j++) {
                const cd = contentDefs[j];
                if (!cd) continue;

                if (!cd.Controls) cd.Controls = [];

                const cdChildren = [];

                for (let i = 0; i < cd.Controls.length; i++) {
                    const c = cd.Controls[i];
                    if (!(typeof c === 'object'))
                        continue;

                    const DynamicControl = utils.getDesignerComponent(c, null);

                    if (!c.$objectId) c.$objectId = utils.generateUUID();

                    let id = `${this.master_key}_${c.$objectId}`;
                    if (index) id = `${index}_${id}`;

                    cdChildren.push(
                        <DynamicControl
                            key={id}
                            type={c.ControlType}
                            name={c.ControlData ? c.ControlData.Name : ''}
                            root={this.root}
                            designmodel={c}
                            parentType={parentType}
                            controlData={c.ControlData}
                            controlURL={c.ControlURL}
                            sourceData={model}
                            controlName={c.Name}
                            sourceIndex={i}
                        />
                    );
                }

                const cdKey = `${index}_cd_${cd.$objectId ?? j}`;
                const showAddControl =
                    this.selected$ &&
                    this.Root.SelectedModel === cd &&
                    isFirstPreviewRow;

                let addBtn = null;
                if (showAddControl) {
                    addBtn = (
                        <QBtn
                            key={`add-${cdKey}`}
                            size="sm"
                            flat
                            icon="mdi-plus-circle"
                            color="blue-8"
                            style={{ zIndex: 992 }}
                            onClick={(e) => this.addControl(e, cd.Controls)}>
                            <QTooltip>Add control</QTooltip>
                        </QBtn>
                    );
                }

                items.push(
                    <div
                        key={cdKey}
                        class={{
                            'for-each-contentdef-dsgn': true,
                            'for-each-contentdef-dsgn--active': this.selected$,
                            'for-each-contentdef-dsgn--selected': this.Root.SelectedModel === cd,
                        }}
                        onClick={(e) => this.selectContentDef(e, cd)}>
                        {cdChildren}
                        {addBtn}
                    </div>
                );
            }
        },
        addContent(e) {
            if (!this.controlData.ContentDefs)
                this.controlData.ContentDefs = [];

            this.controlData.ContentDefs.push({
                $typeSchema: '/schema/public/Platform.Schema.DynamicControls.v1/DynamicControl_ForEach_ContentDef',
                $objectId: utils.generateUUID(),
                Controls: [],
            });
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        type: { type: String, default: null },
        parentType: { type: String, default: null },
        name: { type: String, default: '' },
        root: { type: Object, default: null },
        designmodel: { type: Object, default: null },
        controlData: { type: Object, default: () => ({}) },
    },
    render() {
        try {
            const items = [];
            const items_id = '_0';

            if (this.model && typeof this.model === 'object' && this.controlData.ContentDefs) {
                if (Array.isArray(this.model) && this.model.length > 0) {
                    for (let i = 0; i < this.model.length; i++) {
                        const item = this.model[i];
                        const item_index = `${i}_${items_id}`;
                        const sub_items = [];
                        this.generateItems(h, this.controlData.ContentDefs, sub_items, item, item_index, this.parentType, i === 0);

                        items.push(
                            <div key={item_index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                {sub_items}
                            </div>
                        );
                    }
                }
                else if (Object.keys(this.model).length > 0) {
                    const objKeys = Object.keys(this.model);
                    for (let ki = 0; ki < objKeys.length; ki++) {
                        const key = objKeys[ki];
                        const item = this.model[key];
                        const item_index = `${key}_${items_id}`;
                        const sub_items = [];
                        this.generateItems(h, this.controlData.ContentDefs, sub_items, item, item_index, this.parentType, ki === 0);

                        items.push(
                            <div key={item_index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                {sub_items}
                            </div>
                        );
                    }
                }
                else {
                    const sub_items = [];
                    this.generateItems(h, this.controlData.ContentDefs, sub_items, null, '0', this.parentType, true);

                    items.push(
                        <div key="empty-model" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            {sub_items}
                        </div>
                    );
                }
            }
            else if (this.controlData.ContentDefs) {
                const sub_items = [];
                this.generateItems(h, this.controlData.ContentDefs, sub_items, null, '0', this.parentType, true);

                items.push(
                    <div key="no-model" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        {sub_items}
                    </div>
                );
            }

            if (this.selected$) {
                items.push(
                    <QBtn
                        key="add-content"
                        size="sm"
                        flat
                        icon="mdi-plus-circle"
                        color="red-8"
                        style={{ zIndex: 992 }}
                        onClick={(e) => this.addContent(e)}>
                        <QTooltip>Add content</QTooltip>
                    </QBtn>
                );
            }

            const style = {
                overflow: this.parentType == 'ContentDef' ? 'hidden' : 'auto',
                display: 'flex',
                flexDirection: this.controlData.UseFlexRow ? 'row' : 'column',
                alignItems: 'flex-start',
                ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
                ...utils.getStyleHints(this.controlData.StyleHints),
            };

            return (
                <div
                    class={{
                        'c-ForEach': true,
                        [`c-name-${this.name || 'unnamed'}`]: true,
                        'designer-container': true,
                        selected: this.selected$,
                    }}
                    style={style}
                    onClick={(e) => this.handleClick(e)}>
                    <div class={{ 'designer-container-hovering': true, 'designer-container-selected-clickthrough': this.selected$ }} />
                    {items}
                    {this.generatePicker(h)}
                </div>
            );
        }
        catch (e) {
            utils.error('ForEach Render failed', e);
            return <div>ForEach Failed to Render {String(e)}</div>;
        }
    },
});
